import { type EventName, type PlatformEvent } from '../types';

type ShareSource = 'bar' | 'start' | 'game' | 'ton-bg-task' | 'ingame';

export const makeShareEvent = (
  source: ShareSource,
  gameKey: string,
  hasSent?: boolean
): PlatformEvent => {
  enum ShareSource {
    BAR = 'share_game_wrapper_bar_button',
    INGAME = 'share_game_ingame_button',
    START = 'share_game_wrapper_start_screen',
  }

  const names: { [key: string]: EventName } = {
    bar: ShareSource.BAR,
    start: ShareSource.START,
    ingame: ShareSource.INGAME,
  };

  return {
    type: 'click',
    user_properties: {},
    event_properties: {
      name: names[source],
      game_key: gameKey,
      hasSent,
    },
  };
};
